import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { v4 as uuid } from 'uuid';
import { getTodayISODate } from "../../lib";
import { MessageStatus, MessageType, SessionChannel, SessionStatus, UserType, WSMessageType } from "../types";
export var createSocketMessage = function createSocketMessage(messageContent, _ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? uuid() : _ref$id,
    replyId = _ref.replyId,
    _ref$messageType = _ref.messageType,
    messageType = _ref$messageType === void 0 ? MessageType.Text : _ref$messageType,
    value = _ref.value,
    link = _ref.link;
  return {
    type: WSMessageType.OutgoingMessage,
    data: {
      requestId: id === null || id === void 0 ? void 0 : id.toString(),
      message: {
        type: messageType,
        text: messageContent,
        replyId: replyId,
        value: value,
        link: link
      },
      author: {
        type: UserType.Client
      }
    }
  };
};
export var createSocketImgMessage = function createSocketImgMessage(imageIdGroup, _ref2) {
  var _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? uuid() : _ref2$id;
  return {
    type: WSMessageType.OutgoingMessage,
    data: {
      requestId: id === null || id === void 0 ? void 0 : id.toString(),
      message: {
        type: MessageType.Img,
        filePreviewId: imageIdGroup.imagePreviewId,
        fileId: imageIdGroup.imageId
      }
    }
  };
};
export var createSocketFileMessage = function createSocketFileMessage(fileId, _ref3) {
  var _ref3$id = _ref3.id,
    id = _ref3$id === void 0 ? uuid() : _ref3$id;
  return {
    type: WSMessageType.OutgoingMessage,
    data: {
      requestId: id === null || id === void 0 ? void 0 : id.toString(),
      message: {
        type: MessageType.FileDoc,
        fileId: fileId
      }
    }
  };
};
export var createHistoryMessage = function createHistoryMessage(messageContent, options, data) {
  var _options$id, _options$status, _options$messageType, _data$fileInfo, _data$imageUrlGroup, _data$imageUrlGroup2, _data$imageUrlGroup3, _data$fileInfo2, _data$fileInfo3, _options$author;
  return {
    messageId: (_options$id = options.id) !== null && _options$id !== void 0 ? _options$id : uuid(),
    messageStatus: (_options$status = options.status) !== null && _options$status !== void 0 ? _options$status : MessageStatus.sent,
    date: getTodayISODate(),
    message: {
      type: (_options$messageType = options.messageType) !== null && _options$messageType !== void 0 ? _options$messageType : MessageType.Text,
      content: messageContent,
      replyId: options.replyId,
      fileUrl: options.messageType === MessageType.FileDoc ? data === null || data === void 0 || (_data$fileInfo = data.fileInfo) === null || _data$fileInfo === void 0 ? void 0 : _data$fileInfo.fileUrl : data === null || data === void 0 || (_data$imageUrlGroup = data.imageUrlGroup) === null || _data$imageUrlGroup === void 0 ? void 0 : _data$imageUrlGroup.fileUrl,
      filePreviewUrl: data === null || data === void 0 || (_data$imageUrlGroup2 = data.imageUrlGroup) === null || _data$imageUrlGroup2 === void 0 ? void 0 : _data$imageUrlGroup2.filePreviewUrl,
      imageSettings: data === null || data === void 0 || (_data$imageUrlGroup3 = data.imageUrlGroup) === null || _data$imageUrlGroup3 === void 0 ? void 0 : _data$imageUrlGroup3.imageSettings,
      name: data === null || data === void 0 || (_data$fileInfo2 = data.fileInfo) === null || _data$fileInfo2 === void 0 ? void 0 : _data$fileInfo2.name,
      size: data === null || data === void 0 || (_data$fileInfo3 = data.fileInfo) === null || _data$fileInfo3 === void 0 ? void 0 : _data$fileInfo3.size,
      chips: options.chips,
      value: options === null || options === void 0 ? void 0 : options.value
    },
    author: {
      type: (_options$author = options.author) !== null && _options$author !== void 0 ? _options$author : UserType.Client
    },
    captcha: options.captcha,
    onlyClient: options.onlyClient
  };
};
export var createNewMessages = function createNewMessages(messageContent, _ref4) {
  var id = _ref4.id,
    options = _objectWithoutProperties(_ref4, _excluded);
  var messageId = id !== null && id !== void 0 ? id : uuid();
  var socketMessage = createSocketMessage(messageContent, _objectSpread({
    id: messageId
  }, options));
  var historyMessage = createHistoryMessage(messageContent, _objectSpread({
    id: messageId
  }, options));
  return {
    socketMessage: socketMessage,
    historyMessage: historyMessage
  };
};
export var getNewSession = function getNewSession() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SessionStatus.Created;
  var now = getTodayISODate();
  var session = {
    id: '',
    channel: SessionChannel.Web,
    createdAt: now,
    updatedAt: now,
    status: status,
    messages: []
  };
  return session;
};
export var fromSocketToHistoryMessage = function fromSocketToHistoryMessage(rawMessage) {
  var _rawMessage$data$mess;
  var isIncomingMessage = rawMessage.type === WSMessageType.IncomingMessage;
  var messageDate = isIncomingMessage ? rawMessage.data.timestamp : getTodayISODate();
  var authorType = isIncomingMessage ? UserType.Bot : UserType.Client;
  var message = {
    date: messageDate,
    messageId: uuid(),
    messageStatus: MessageStatus.delivered,
    message: {
      type: MessageType.Text,
      content: rawMessage.data.message.text
    },
    author: rawMessage.data.author || {
      type: authorType
    }
  };
  return {
    historyMessage: message,
    quickReplies: ((_rawMessage$data$mess = rawMessage.data.message) === null || _rawMessage$data$mess === void 0 ? void 0 : _rawMessage$data$mess.quickReplies) || []
  };
};
export var getMockOperatorInitialMessage = function getMockOperatorInitialMessage(text) {
  return {
    author: {
      type: UserType.Operator
    },
    date: new Date().toISOString(),
    message: {
      content: text,
      type: MessageType.Text
    },
    messageId: 'mock-operator-message',
    messageStatus: MessageStatus.delivered
  };
};